import Pusher from "pusher-js";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useMatch } from "react-router-dom";
import { updateCheckIn } from "../reducers/checkinSlice";
import { getCurrentUser } from "../app/gs-session";
import { HmacSHA1 } from "crypto-js";
import Base64 from "crypto-js/enc-base64";

export const usePusherTeamCheckin = () => {
  const dispatch = useDispatch();
  const match = useMatch("/:tournamentKey/*");
  const tournamentKey = match?.params?.tournamentKey;

  const gsSessionUser = getCurrentUser();

  const channelName = `private-check-ins-${tournamentKey}`;

  let golfstatusToken = gsSessionUser.golfstatusToken;

  let signatureString = `${channelName},${gsSessionUser.email},${gsSessionUser.uid}`;

  let hmac = new HmacSHA1(signatureString, golfstatusToken);
  let authString = Base64.stringify(hmac);

  useEffect(() => {
    const pusher = new Pusher(process.env.REACT_APP_PUSHER_KEY, {
      cluster: process.env.REACT_APP_PUSHER_CLUSTER,
      channelAuthorization: {
        endpoint: `${process.env.REACT_APP_GOLFSTATUS_BASE_API_URL}pusher/auth`,
        headers: {
          "Auth-signature": authString,
          "User-Key": gsSessionUser.uid,
        },
      },
    });

    const channel = pusher.subscribe(`private-check-ins-${tournamentKey}`);
    channel.bind("team-check-in", (data) => {
      dispatch(updateCheckIn(data));
    });

    return () => {
      channel.unbind("team-check-in");
      pusher.unsubscribe(`private-check-ins-${tournamentKey}`);
      pusher.disconnect();
    };
  }, [dispatch, tournamentKey, authString, gsSessionUser.uid]);
};
